const validateTransferStatus = {
  WAITING: 'AGUARDANDO',
  APPROVED: 'APROVADO',
  DENIED: 'REJEITADO',
  JUMP: 'PULADO'
};

module.exports = validateTransferStatus;
